import { registerSW } from "virtual:pwa-register";

/**
 * Registers the self-destroying service worker (production builds only).
 *
 * There is no caching worker any more, and no "new version available" toast:
 * a deploy is picked up on the next page load like any web app, because
 * index.html is served no-cache and the assets are content-hashed. What this
 * registers is the worker that unregisters itself and clears the caches the
 * old one left behind, in browsers that installed it. See vite.config.ts.
 */
export function registerServiceWorker() {
  if (!import.meta.env.PROD) return;
  registerSW({ immediate: true });
}
